import * as React from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { Typography, Divider } from '@mui/material';

const styles = {
    groupArea: {
        paddingTop: "8px",
        paddingBottom: "8px"
    }
}

interface IFilterSelectModalProps {
    canFilterByMonitoringStatus: boolean;
    onConfirm: (value: FeedbackTableFiltersViewModel) => void
    filterList: FeedbackTableFiltersViewModel
}

interface IFilterSelectModalState {
    open: boolean,
    filters: FeedbackTableFiltersViewModel
}

export class FeedbackSelectModal extends React.Component<IFilterSelectModalProps, IFilterSelectModalState>{
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            filters: this.props.filterList
        };
    }

    public HandleSelect = (value: string, newValue?: boolean) => {
        if (newValue === undefined) {
            this.setState(prevState => ({
                filters: {
                    ...prevState.filters,
                    [value]: !prevState.filters[value]
                }
            }));
        }
        else {
            this.setState(prevState => ({
                filters: {
                    ...prevState.filters,
                    [value]: newValue
                }
            }));
        }
    }

    public HandleDate = (value: string) => {
        const oldValue = this.state.filters[value];
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                flagCompletionToday: false,
                flagCompletionYesterday: false,
                flagCompletionThisWeek: false,
                flagCompletionLastWeek: false,
                flagCompletionSingleDate: false,
                flagCompletionDateRange: false
            }
        }));
        this.HandleSelect(value, !oldValue);
    }

    public HandleTime = (value: string) => {
        const oldValue = this.state.filters[value];
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                flagCompletionTimeRange: false
            }
        }));
        this.HandleSelect(value, !oldValue);
    }

    public Open = () => {
        this.setState({
            open: true,
            filters: this.props.filterList
        });
    }

    public Close = () => {
        this.setState({ open: false, });
    }

    public Confirm = () => {
        this.setState({ open: false, });
        this.props.onConfirm(this.state.filters);
    }

    public render() {
        const classes = styles;
        return (
            <Grid>
                <Chip
                    label="Select Filters"
                    clickable
                    onClick={this.Open}
                />
                <Dialog
                    open={this.state.open}
                    onClose={this.Close}
                    maxWidth="lg"
                    fullWidth>
                    <DialogTitle>
                        Select Filters
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={1}>
                            <Grid size={6}>
                                <Typography variant="h6">Completion Date / Time Filters</Typography>
                                <Divider />
                                <Grid container spacing={1} sx={classes.groupArea}>
                                    <ToggleChip selected={this.state.filters.flagCompletionToday} key={this.state.filters.flagCompletionToday.toString() + "flagCompletionToday"} value="flagCompletionToday" label="Completed Today" onSelect={this.HandleDate} />
                                    <ToggleChip selected={this.state.filters.flagCompletionYesterday} key={this.state.filters.flagCompletionYesterday.toString() + "flagCompletionYesterday"} value="flagCompletionYesterday" label="Completed Yesterday" onSelect={this.HandleDate} />
                                    <ToggleChip selected={this.state.filters.flagCompletionThisWeek} key={this.state.filters.flagCompletionThisWeek.toString() + "flagCompletionThisWeek"} value="flagCompletionThisWeek" label="Completed This Week" onSelect={this.HandleDate} />
                                    <ToggleChip selected={this.state.filters.flagCompletionLastWeek} key={this.state.filters.flagCompletionLastWeek.toString() + "flagCompletionLastWeek"} value="flagCompletionLastWeek" label="Completed Last Week" onSelect={this.HandleDate} />
                                    <ToggleChip selected={this.state.filters.flagCompletionSingleDate} key={this.state.filters.flagCompletionSingleDate.toString() + "flagCompletionSingleDate"} value="flagCompletionSingleDate" label="Completed Single Date" onSelect={this.HandleDate} />
                                    <ToggleChip selected={this.state.filters.flagCompletionDateRange} key={this.state.filters.flagCompletionDateRange.toString() + "flagCompletionDateRange"} value="flagCompletionDateRange" label="Completed Date Range" onSelect={this.HandleDate} />
                                    <ToggleChip selected={this.state.filters.flagCompletionTimeRange} key={this.state.filters.flagCompletionTimeRange.toString() + "flagCompletionTimeRange"} value="flagCompletionTimeRange" label="Completed Time Range" onSelect={this.HandleTime} />
                                </Grid>
                            </Grid>
                            <Grid size={6}>
                                <Typography variant="h6">Additional Filters</Typography>
                                <Divider />
                                <Grid container spacing={1} sx={classes.groupArea}>
                                    <ToggleChip selected={this.state.filters.flagClient} key={this.state.filters.flagClient.toString() + "flagClient"} value="flagClient" label="Client" onSelect={this.HandleSelect} />
                                    <ToggleChip selected={this.state.filters.flagChannel} key={this.state.filters.flagChannel.toString() + "flagChannel"} value="flagChannel" label="Channel" onSelect={this.HandleSelect} />
                                    <ToggleChip selected={this.state.filters.flagTeamLeader} key={this.state.filters.flagTeamLeader.toString() + "flagTeamLeader"} value="flagTeamLeader" label="Team Leader" onSelect={this.HandleSelect} />
                                    <ToggleChip selected={this.state.filters.flagAgentName} key={this.state.filters.flagAgentName.toString() + "flagAgentName"} value="flagAgentName" label="Agent Name" onSelect={this.HandleSelect} />
                                    <ToggleChip selected={this.state.filters.flagStatus} key={this.state.filters.flagStatus.toString() + "flagStatus"} value="flagStatus" label="Status" onSelect={this.HandleSelect} />
                                    <ToggleChip selected={this.state.filters.flagAlert} key={this.state.filters.flagAlert.toString() + "flagAlert"} value="flagAlert" label="Alert" onSelect={this.HandleSelect} />
                                    <ToggleChip selected={this.state.filters.flagResult} key={this.state.filters.flagResult.toString() + "flagResult"} value="flagResult" label="Result" onSelect={this.HandleSelect} />
                                    {
                                        this.props.canFilterByMonitoringStatus &&
                                        <ToggleChip selected={this.state.filters.flagMonitoringStatus} key={this.state.filters.flagMonitoringStatus.toString() + "flagMonitoringStatus"} value="flagMonitoringStatus" label="Monitoring Status" onSelect={this.HandleSelect} />
                                    }
                                    <ToggleChip selected={this.state.filters.flagMonitoredBy} key={this.state.filters.flagMonitoredBy.toString() + "flagMonitoredBy"} value="flagMonitoredBy" label="Monitored By" onSelect={this.HandleSelect} />
                                    <ToggleChip selected={this.state.filters.flagScorecardType} key={this.state.filters.flagScorecardType.toString() + "flagScorecardType"} value="flagScorecardType" label="Scorecard Type" onSelect={this.HandleSelect} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.Confirm} color="primary">Confirm</Button>
                        <Button onClick={this.Close} color="primary">Cancel</Button>
                    </DialogActions>
                </Dialog>
            </Grid >
        );
    }
}

export default FeedbackSelectModal;

import CheckCircle from '@mui/icons-material/CheckCircle';
import AddCircle from '@mui/icons-material/AddCircle';
import FeedbackTableFiltersViewModel from '../Feedback/ViewModels/FeedbackTableFiltersViewModel';

interface IToggleChipProps {
    value: string,
    label?: string,
    selected: boolean,
    onSelect: (value: string) => void,
}

export class ToggleChip extends React.Component<IToggleChipProps, any> {
    constructor(props) {
        super(props);
    }

    public render() {
        const text = this.props.label !== undefined ? this.props.label : this.props.value;
        return (
            <Grid>
                <Chip
                    color={this.props.selected ? "secondary" : "default"}
                    label={text}
                    clickable
                    onClick={this.HandleClick}
                    onDelete={this.HandleClick}
                    deleteIcon={this.props.selected ? <CheckCircle /> : <AddCircle />}
                />
            </Grid>
        );
    }

    public HandleClick = () => {
            this.props.onSelect(this.props.value);
    }
}